import React from "react";

import { Tooltip } from "@amphore-dev/amphore-lib";
import { EventClickArg, EventContentArg } from "@fullcalendar/core";

import { Dot, TaskDateRange } from "@/components/atoms";

interface CalendarEventProps extends EventContentArg {
	onClick?: (props: EventClickArg) => void;
}

export const CalendarEvent: React.FC<CalendarEventProps> = (props) => {
	return (
		<Tooltip
			content={
				<div className="col gap-1">
					<div className="row text-2xs items-center gap-1">
						<Dot
							color={props.event.backgroundColor}
							className="h-2 w-2 min-w-2"
						/>
						{props.event.extendedProps?.project?.name}
					</div>
					<b>{props.event.title}</b>
					<div className="row text-2xs gap-1 text-neutral-500">
						<TaskDateRange
							start={props.event.start!}
							end={props.event.end ? props.event.end : undefined}
						/>
					</div>
				</div>
			}
			portal={true}
		>
			<button
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					props.onClick?.(props as unknown as EventClickArg);
				}}
				className="z-0 block"
				data-testid="calendar-event"
				data-task-id={props.event.extendedProps?.id}
			>
				<span
					className="fc-daygrid-event-dot block"
					style={{ borderColor: props.backgroundColor }}
				/>
			</button>
		</Tooltip>
	);
};
